/**
 * 用户协议请求接口
 * @author 王振宇
 * @since 2022-05-31
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_USERAGREEMENT_PAGE_LIST: function GET_USERAGREEMENT_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_USERAGREEMENT_LIST: function GET_USERAGREEMENT_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/getList',
        method: 'get',
        params: data
      });
    },
    GET_USERAGREEMENT_INFO: function GET_USERAGREEMENT_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/info',
        method: 'get',
        params: data
      });
    },
    SAVE_USERAGREEMENT: function SAVE_USERAGREEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_USERAGREEMENT: function UPDATE_USERAGREEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/update',
        method: 'put',
        data: data
      });
    },
    DELETE_USERAGREEMENT: function DELETE_USERAGREEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_USERAGREEMENT: function DELETE_BATCH_USERAGREEMENT() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      return request({
        url: '/admin/v1/userAgreement/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});